var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInstag(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 37,
    viewBox: "0 0 39 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.4155 36.4572H11.7803C5.28494 36.4572 0 31.1723 0 24.6761V11.7795C0 5.2841 5.28494 0 11.7803 0H26.4155C32.9101 0 38.195 5.2841 38.195 11.7795V24.6761C38.195 31.1715 32.9101 36.4572 26.4155 36.4572ZM11.7803 2.61748C6.7278 2.61748 2.61831 6.7278 2.61831 11.7795V24.6761C2.61831 29.7286 6.7278 33.8381 11.7803 33.8381H26.4155C31.4672 33.8381 35.5775 29.7278 35.5775 24.6761V11.7795C35.5775 6.7278 31.4672 2.61748 26.4155 2.61748H11.7803Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0979 28.7139C13.3156 28.7139 8.61218 24.0096 8.61218 18.2282C8.61218 12.4468 13.3156 7.74247 19.0979 7.74247C24.8802 7.74247 29.5837 12.4459 29.5837 18.2282C29.5837 24.0105 24.8802 28.7139 19.0979 28.7139ZM19.0979 10.3591C14.7593 10.3591 11.2297 13.8888 11.2297 18.2274C11.2297 22.566 14.7593 26.0956 19.0979 26.0956C23.4365 26.0956 26.9662 22.566 26.9662 18.2274C26.9662 13.8888 23.4365 10.3591 19.0979 10.3591Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5988 8.06486C31.5988 9.26614 30.6249 10.24 29.4236 10.24C28.2224 10.24 27.2477 9.26614 27.2477 8.06486C27.2477 6.86359 28.2224 5.88891 29.4236 5.88891C30.6249 5.88891 31.5988 6.86276 31.5988 8.06486Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstag);
export default __webpack_public_path__ + "static/media/instag.500eb032e48bedc61ea3fa8aa05eee92.svg";
export { ForwardRef as ReactComponent };